const _excluded = ["showTemplatesDivider"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useCurrentProject, useCurrentProjectIsTemplate, useCurrentProductId, TOOL_IDS } from '@adsk/alloy-provider';
import SideNavigation, { SideNavigationItem } from '@adsk/alloy-side-navigation';
import ProjectTemplateSettingsSideNavigationItem from './ProjectTemplateSettingsSideNavigationItem';
const useNavigationItems = () => {
  const currentProject = useCurrentProject();
  const currentProductId = useCurrentProductId();
  return useMemo(() => {
    var _currentProject$produ, _currentProject$produ2;
    return (currentProject === null || currentProject === void 0 ? void 0 : (_currentProject$produ = currentProject.products) === null || _currentProject$produ === void 0 ? void 0 : (_currentProject$produ2 = _currentProject$produ.find(p => p.key === currentProductId)) === null || _currentProject$produ2 === void 0 ? void 0 : _currentProject$produ2.tools) || [];
  }, [currentProject, currentProductId]);
};
const ProjectTemplateSideNavigationItem = _ref => {
  let {
      showTemplatesDivider
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (props.item.key === TOOL_IDS.CONFIGURATION) {
    return /*#__PURE__*/React.createElement(ProjectTemplateSettingsSideNavigationItem, _extends({
      showTemplatesDivider: showTemplatesDivider
    }, props));
  }
  return /*#__PURE__*/React.createElement(SideNavigationItem, props);
};
ProjectTemplateSideNavigationItem.propTypes = SideNavigationItem.propTypes;
const ConnectedSideNavigation = _ref2 => {
  let {
    selectedId,
    route
  } = _ref2;
  const currentProjectIsTemplate = useCurrentProjectIsTemplate();
  const navigationItems = useNavigationItems();
  const showTemplatesDivider = currentProjectIsTemplate && navigationItems.filter(item => item.key !== TOOL_IDS.CONFIGURATION).length > 0;
  return /*#__PURE__*/React.createElement(SideNavigation, {
    selectedId: selectedId,
    route: route,
    topItems: navigationItems,
    renderItem: currentProjectIsTemplate ? props => /*#__PURE__*/React.createElement(ProjectTemplateSideNavigationItem, _extends({
      showTemplatesDivider: showTemplatesDivider
    }, props)) : /* use default prop value */undefined
  });
};
ConnectedSideNavigation.propTypes = {
  /** Location path of current view */
  route: PropTypes.string,
  /** The current selected service ID */
  selectedId: PropTypes.string
};
export { ConnectedSideNavigation };
//# sourceMappingURL=ConnectedSideNavigation.js.map